var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",value:(_vm.messageTooltip),expression:"messageTooltip",modifiers:{"hover":true}}],class:_vm.bgColor},[_c('b-icon',{staticStyle:{"width":"0.40em"},attrs:{"icon":"circle-fill","variant":_vm.variant}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }